import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Button, Space } from 'antd';
import EditIcon from '../EditIcon';
import Trash from '../../Assets/images/recycle-bin.png';
import HospitalImage from '../../Assets/images/hospital.png'
import { width } from '@fortawesome/free-brands-svg-icons/fa42Group';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useParams } from "react-router";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { usePermissions } from '../../../Services/PermissionsContext'; // Import the permissions context
import { hasPermission } from '../../../Services/checkPermissions';   // Import the helper function
import ViewIcon from '../Menumanagement/View';
import OrderInfo from '../DeliveryAgents/OrderInfo';
import Close from '../../Assets/images/close.png';

const CollectionAgent = () => {

  const permissions = usePermissions(); // Get global permissions
  const navigate = useNavigate();
  const params = useParams();
  const [Data, setData] = useState([]);
  const { organization } = useContext(OrganizationContext);
  //const [selectedRows, setSelectedRows] = useState([]);
  //const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  //const [selectedRecord, setselectedRecord] = useState([]);
  //const [agents, setdeliveryagents] = useState([]);
  //const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    search: '',
  });
  const [status, setStatus] = useState("Status");
  const Packagedata = [];

  useEffect(() => {
    if (organization) {
      loadAgentSettlement();
      //loadDeliveryAgents();
    }
  }, [organization]);


  const stripHtmlTags = (str) => {
    if (!str) return '';
    return str.replace(/<[^>]*>/g, '');
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // const showModal = (record) => {
  //   setselectedRecord(record);
  //   setIsModalVisible(true);
  // };

  // const closeModal = (record) => {
  //   setIsModalVisible(false);
  //   setselectedRecord(record);
  // };


  const loadAgentSettlement = () => {
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    // Construct the URL with the organization_id as a query parameter
    const url = new URL(authService.getApiUrl() + 'settlementconfirmation');
    //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter

    fetch(url, {
      method: 'POST', // Set method to GET
      body: JSON.stringify({
        cash_collection_agent_id: authService.getCurrentadmin().UserInfo.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
      },
    })
      .then((res) => {
        if (res.status === 401) {
          // If status is 401, redirect to the login page
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json(); // Proceed with parsing JSON if the response is okay
        }
      })
      .then((result) => {
        //setData(result.data); // Set the category data in state
        setData(result.data);
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });

  };

  // const loadDeliveryAgents = () => {
  //   const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

  //   // Construct the URL with the organization_id as a query parameter
  //   const url = new URL(authService.getApiUrl() + 'deliveryagentslist');
  //   //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter

  //   fetch(url, {
  //     method: 'POST', // Set method to GET
  //     body: JSON.stringify({
  //       organization_id: organization,
  //       page: 1,
  //     }),
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json; charset=UTF-8',
  //       Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
  //     },
  //   })
  //     .then((res) => {
  //       if (res.status === 401) {
  //         // If status is 401, redirect to the login page
  //         authService.logout();
  //         window.location.href = "/admin";
  //       } else {
  //         return res.json(); // Proceed with parsing JSON if the response is okay
  //       }
  //     })
  //     .then((result) => {
  //       //setData(result.data); // Set the category data in state
  //       setdeliveryagents(result.data);
  //     })
  //     .catch((err) => {
  //       console.log(err.message); // Handle any errors
  //     });

  // };


  // const handleStatusChange = (value) => {
  //   const token = authService.getCurrentadmin().token;

  //   fetch(authService.getApiUrl() + "agentstatuschange", {
  //     method: "PUT",
  //     body: JSON.stringify({
  //       status: value,
  //       id: selectedRowKeys,
  //       organization_id: organization,
  //     }),
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json; charset=UTF-8",
  //       Authorization: `Bearer ${token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       loadDeliveryAgentorders();
  //     })
  //     .catch((err) => {
  //       console.log(err.message);
  //     });
  // };

  // const handleassignagent = (agentId, record) => {
  //   // console.log("Selected Agent ID:", agentId);
  //   // console.log("Selected Order ID:", record.id); // Ensure 'id' is present in your record

  //   const token = authService.getCurrentadmin().token;

  //   fetch(authService.getApiUrl() + "orderassigning", {
  //     method: "POST",
  //     body: JSON.stringify({
  //       order_id: record.order_id,  // Selected Agent ID
  //       assign_to: agentId,    // Order ID
  //     }),
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json; charset=UTF-8",
  //       Authorization: `Bearer ${token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       loadAgentSettlement(); // Refresh order list after update
  //     })
  //     .catch((err) => {
  //       console.log("Error:", err.message);
  //     });
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: (newSelectedRowKeys) => {
  //     console.log("Selected Row Keys:", newSelectedRowKeys);
  //     setSelectedRowKeys(newSelectedRowKeys);
  //   },
  // };

  const columns = [
    {
      title: "Phlebotomist Name",
      dataIndex: "phlebotomist_name",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.date.length - b.date.length,
    },

    {
      title: "Due Amount",
      dataIndex: "due_amount",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      title: "Collection Agent Name",
      dataIndex: "cash_collection_name",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      title: "Date&Time",
      dataIndex: "date_time",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.date.length - b.date.length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text) => (
        <span className={text === 'Approved' ? 'status-btn-green' : 'status-btn-red'}>
          {text}
        </span>
      ),
    },

    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {record.status === 'Pending' && (
            <span className='status-btn-green' style={{ whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={() => updateOrderStatus(record)}>Approved</span>
          )}
        </Space>
      ),
    },
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    fetch(authService.getApiUrl() + 'search', {
      method: 'POST', // Change method to PUT
      body: JSON.stringify({
        search: formData.search,
        user_id: authService.getCurrentadmin().UserInfo.id,
      }), // Include the data to be updated in the body
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.data); // Set the category data in state
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });

  };


  const updateOrderStatus = (data) => {
    //event.preventDefault();
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    fetch(authService.getApiUrl() + 'settlementconfirmation/' + data.id, {
      method: 'PUT', // Change method to PUT
      // body: JSON.stringify({
      //   order_id: data.order_id,
      //   order_status_id: status,
      // }), // Include the data to be updated in the body
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => res.json())
      .then((result) => {
        loadAgentSettlement(); // Set the category data in state
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });

  };

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <>
      <div className='main-container'>
        <div className='container-fluid'>
          <Breadcrumb />
          <div className='category-table'>
            <div className='flex-cont add-cat'>
              <div className='heading'>
                <h3>Cash Collection Agent</h3>
              </div>
            </div>
            <div className='flex-cont just-cont-left bord-botm'>
              <div className='filter-search'>
                <input
                  type='text'
                  className='category-search'
                  placeholder='Search by date'
                  onChange={handleInputChange}
                  name="search"
                  id="search"
                />
                <Button type='submit' onClick={handleSubmit}>Search</Button>
              </div>
            </div>
            <div className='hospitals-table' id='hospitals_table'>
              <Table
                dataSource={Data}
                columns={columns}
                pagination={{ pageSize: 10 }}
                rowKey={(record) => record.id}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default CollectionAgent;
